import type { ReactNode } from 'react';
import { LazyMotion, MotionConfig, domAnimation } from 'motion/react';

/**
 * Zet animaties klaar voor de hele app. Gebruik overal `m.div` (uit 'motion/react') in plaats van
 * `motion.div`: dat scheelt veel kilobytes. `strict` laat een gewone `motion.*` meteen als fout zien.
 * `reducedMotion="user"` respecteert de systeeminstelling "minder beweging".
 */
export function MotionRoot({ children }: { children: ReactNode }) {
  return (
    <LazyMotion features={domAnimation} strict>
      <MotionConfig reducedMotion="user">{children}</MotionConfig>
    </LazyMotion>
  );
}
